export const DESCRIPTION_LIMIT = 150;
export const SELECTOR_MODAL_USERS = '.modalUsers';
